import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthResponse } from '@api/*';

export const AuthUserActions = createActionGroup({
  source: 'User Authentication',
  events: {
    'Initialize Public Authentication': props<{ username: string | null; password: string | null }>(),
    'Initialize Public Authentication Success': props<{ response: AuthResponse }>(),
    'Initialize Public Authentication Failure': props<{ error: string }>(),

    'Validate Public Authentication': emptyProps(),
    'Validate Public Authentication Success': emptyProps(),
    'Validate Public Authentication Failure': props<{ error: string }>(),

    'Customer Logout': emptyProps(),
  },
});
